import React, { useEffect, useState } from "react";
import { Grid, Box, Button, FormLabel, TextField, Typography } from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";

interface Prop {
  onClose: () => void;
  id?: any;
}
const BlockFrom: React.FC<Prop> = ({ onClose, id }) => {
  const [formData, setFromData] = useState<any>();
  const [initialFromData, setInitialFromData] = useState<any>();
  const handleAdd = async () => {
    try {
      const resp = await axiosInstance.post(
        "/api/block?invocation=0",
        formData
      );
      if (resp?.status === 200) {
        toast.success("Block Created Successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  const handleEdit = async () => {
    try {
      const resp = await axiosInstance.put(
        `/api/block/${id}?invocation=0`,
        formData
      );
      if (resp?.status === 200) {
        toast.success("Block details updated successfully");
        onClose();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleGet = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/block/${id}`);
      if (resp.status === 200) {
        setFromData(resp?.data?.data);
        setInitialFromData(resp?.data?.data);
      }
    } catch (Error: any) {
      toast.error(Error?.response?.data?.message);
    }
  };

  const handleChage = (field: string, value: string) => {
    setFromData((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (id) {
      const noFieldChanges =
        JSON.stringify(initialFromData) === JSON.stringify(formData);
      if (noFieldChanges) {
        toast.info("No changes were made");
        return;
      }
    }

    if (!formData?.block_name) {
      toast.error("Block name is reqiured ");
      return;
    }
    if (id) {
      await handleEdit();
    } else {
      await handleAdd();
    }
  };
  useEffect(() => {
    id && handleGet(id);
  }, []);
  return (
    <div>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            {id ? "Edit Block" : " Add Block"}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>
              Block Name<span style={{ color: "red", marginRight: 4 }}>*</span>
            </FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.block_name}
              onChange={(e: any) => handleChage("block_name", e?.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={12} display={"flex"} justifyContent={"end"}>
          {" "}
          <Box display={"display"}>
            <Button
              size="small"
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default BlockFrom;
